// extracted by mini-css-extract-plugin
export default {"card":"TalentPartnerCard_card__+sy9h","content":"TalentPartnerCard_content__WeHgJ","card-image":"TalentPartnerCard_card-image__KA-Lx","desc":"TalentPartnerCard_desc__8LBiy"};